import React, { useState, useEffect } from 'react';
import { currentPositions } from 'react-scale/components/website/careers/currentPositions';
import Image from 'next/image';
import _ from 'lodash';
import Link from 'next/link';

import { fetchData } from 'react-scale/pages/api/careers/jobs-call';

const Departments = () => {
  const [jobListings, setJobListings] = useState([]);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    async function fetchJobData() {
      try {
        const data = await fetchData();
        setJobListings(data.jobListings);
        setDepartments(data.departments);
      } catch (error) {
        // Handle error if needed
      }
    }

    fetchJobData();
  }, []);

  const departmentsClean = departments.filter(department =>
    jobListings.find(job =>
      job.departments.find(jobDepartment => jobDepartment.id === department.id)
    )
  );

  return (
    <nav className="mx-auto rounded-lg shadow-xl bg-neutral-900">
      <h3 className="block w-full text-sm font-medium tracking-widest text-center text-white uppercase border-b border-neutral-800 py-7">
        Open Roles
      </h3>
      <ul className="grid grid-cols-3 gap-8 p-8 lg:grid-cols-6">
        {departmentsClean.map(d => (
          <DepartmentButton department={d.name} key={d.name} />
        ))}
      </ul>
    </nav>
  );
};

const DepartmentButton = ({ department }) => {
  const positionIcon = _.snakeCase(department.toLowerCase());
  return (
    <li>
      <Link
        href={`/careers?department=${department}&location=#jobs`}
        className="flex flex-col items-center justify-between cursor-pointer shrink-0 group"
      >
        <div className="relative mb-2 md:mb-3">
          {currentPositions.includes(positionIcon) ? (
            <Image
              width={32}
              height={32}
              src={`/static/images/icons/careers/${positionIcon}.svg`}
              alt={`icon for ${department} team`}
            />
          ) : (
            <Image
              width={32}
              height={32}
              src="/static/images/icons/careers/business.svg"
              alt={`icon for ${department} team`}
            />
          )}
        </div>
        <p className="text-sm text-center text-white">{department}</p>
      </Link>
    </li>
  );
};

export default Departments;
